import moment from 'moment';
import 'moment-timezone';

export const getTimezoneOptions = () => {
  return moment.tz.names().map((item) => {
    return { text: item.split('/').join(' '), value: item };
  });
};
